import { render, staticRenderFns } from "./add.vue?vue&type=template&id=67745a70&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67745a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67745a70')) {
      api.createRecord('67745a70', component.options)
    } else {
      api.reload('67745a70', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=67745a70&scoped=true", function () {
      api.rerender('67745a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/client/add.vue"
export default component.exports